export default {
  team_term: 'lag',
  days_until_start:
    '%{smart_count} dag til kampanjen starter |||| %{smart_count} dager til kampanjen starter',
  now_over: 'Kampanjen er nå over',
};
